import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import HalfSizeBanner from '../../../components/Banners/HalfSizeBanner';
import TextBtnSection from '../../../components/Section/TextBtnSection';
import SmallCards from '../../../components/Cards/SmallCards';
import BigCard from '../../../components/Cards/BigCard';
import { Typography } from '@mui/material';
import Accordions from '../../../components/Accordions/Accordions';
import Cards from '../../../components/Cards/Cards';
import { useTranslation } from '../../../hook/Translation';

export default function ExionFaceApplicator() {
const { t } = useTranslation();
   const data2 = [
        {
            imageUrl: '/images/fractional/hourglass-end.svg',
            title: t('time'),
            description:  t('exion_face_applicator.time'),
        },
        {
            imageUrl: '/images/fractional/headache.svg',
            title: t('discomfort'),
            description:  t('exion_face_applicator.discomfort'),
        },
        {
            imageUrl: '/images/fractional/duration.svg',
            title: t('downtime'),
            description:  t('exion_face_applicator.downtime'),
        },
        {
            imageUrl: '/images/fractional/facial-treatment.svg',
            title: t('sessions'),
            description:  t('exion_face_applicator.sessions'),
        }
    ];

    const accodirons = [
        {
            title: t('what'),
            content: t('exion_face_applicator.what')
        },
        {
            title: t('how'),
            content: t('exion_face_applicator.how')
        },
        {
            title: t('benefits'),
            content: t('exion_face_applicator.benefits')
        },
        {
            title: t('zone'),
            content: t('exion_face_applicator.zone')
        },
        {
            title: t('pairs'),
            content: t('exion_face_applicator.pairs')
        },
        {
            title: t('when_expected_results'),
            content: t('exion_face_applicator.expected_results')
        },
        {
            title: t('results'),
            content: t('exion_face_applicator.results')
        },
    ]

    return (
        <Box>

            <Box>
                <HalfSizeBanner>
                    <Box height={'100%'} bgcolor={'#1E353D'}>
                        <Box component={'img'} src={`${process.env.REACT_APP_SITE_URL}/images/2026/05/img_69f855ffb11515.44546088.jpg`} loading='lazy' height={1} width={1} className='fitCover' />
                    </Box>
                </HalfSizeBanner>
            </Box>
            <Box className="generalContainer" marginX={'auto'} marginTop={{ md: '80px', xs: '50px' }}>
                <TextBtnSection
                    titleSize={{ md: 5, xs: 12 }}
                    data={{
                        type: t('skinTherapies'),
                        title: t('exion_face_applicator.mainTitle'),
                        description: t('exion_face_applicator.mainDesc'),
                        bookUrl: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e EXION FACE")}`,
                        learn: "",
                        price: `${t('exion_face_applicator.face&neck')}: €150\n${t('price_package')} 6 ${t('price_seanc')}: €750`,
                        // price: `${t('price_session')} €350\n${t('price_package')} 4 ${t('price_seanc')}: €950`
                        doctorIncluded: true
                    }}
                />
            </Box>
            <Box marginTop={{ md: '107px', xs: '50px' }}>
                <Box component={'img'} src='/images/fractional/Path 134.svg' width={1} sx={{ objectFit: 'cover' }} />
            </Box>

            <Box>
                <Box marginTop={{ md: '104px', xs: '50px' }} className='generalContainer' marginX={'auto'}>
                    <SmallCards data={data2} />
                </Box>
            </Box>

            <Box sx={{ width: { md: '65%', xs: '90%' }, marginX: 'auto' }} marginTop={{ md: '90px', xs: '50px' }}>
                <Box sx={{ height: { md: 440, xs: 'auto' } }}>
                    <BigCard
                        data={{
                            book: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e EXION FACE")}`,
                            // learn: '/',
                            type: t('exion_face_applicator.tech'),
                            descriptionSize: 12,
                            title: t('exion_face_applicator.techTitle'),
                            size: { md: 6, xs: 12 },
                            btnContainer: { md: 12, xs: 12 },
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/01/ALMA-4.png`,
                            flexDirection: { md: 'row-reverse', xs: 'column-reverse' },
                            description: t('exion_face_applicator.techDesc')
                        }}
                    />
                </Box>
                
            </Box>
            <Grid container spacing={4} className="generalContainer" sx={{ marginX: 'auto', marginTop: { md: '80px', xs: '50px' } }} mb={{md: '84px', xs: '50px'}}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={'bold'}>{t('additional_information')}</Typography>
                </Grid>
                <Grid size={12}>
                    <Accordions data={accodirons} />
                </Grid>
            </Grid>

            {/* <Grid container spacing={6} className="generalContainer" sx={{ marginX: 'auto', marginTop: { md: '113px', xs: '50px' } }} mb={{md: '84px', xs: '50px'}}>
                <Grid size={12}>
                    <Grid container spacing={3} justifyContent={'center'}>
                        <Grid size={12}>
                            <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'} >Treatment Areas</Typography>
                        </Grid>
                        <Grid size={{ md: 8, xs: 12 }}>
                            <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1rem'}>Most often done on the face, jawline, and neck for anti-aging and scar revision, but also effective on certain body areas (such asacne-scarred shoulders or stretch marks on abdomen/thighs).</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={12}>
                    <Cards data={data} imageHeight={'340px'} headerAlign={'center'} descriptionAlign={'center'} buttonAlign={'auto'} sizes={{ xs: 12, sm: 6, md: 6, lg: 6 }} />
                </Grid>
            </Grid> */}

        </Box>
    )
}